import { render } from "./AfterSave.vue?vue&type=template&id=f5cc6040&scoped=true"
import script from "./AfterSave.vue?vue&type=script&lang=js"
export * from "./AfterSave.vue?vue&type=script&lang=js"

import "./AfterSave.vue?vue&type=style&index=0&id=f5cc6040&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5cc6040"

export default script